import React from "react";
import PropTypes from "prop-types";
import { formatQueryMetric } from "components/QueryBuilder/Utils/QueryBuilderUtils";
/**
 * Renders the Prediction info for Tooltip
 * @param {*} tooltipPayload
 * @returns
 */
const QueryBuilderTooltipPrediction = ({ tooltipPayload, metrics }) => {
  const predictedValue =
    tooltipPayload.prediction.pred || tooltipPayload.prediction.predicted;
  const highestValue = tooltipPayload.prediction.predMaxMin
    ? tooltipPayload.prediction.predMaxMin[0]
    : tooltipPayload.prediction.predMinMax[1];
  const lowestValue = tooltipPayload.prediction.predMaxMin
    ? tooltipPayload.prediction.predMaxMin[1]
    : tooltipPayload.prediction.predMinMax[0];

  return (
    <main className="standard-tooltip__module">
      <div className="standard-tooltip__item_group">
        <span
          className="standard-tooltip__key text-uppercase"
          style={{ color: tooltipPayload.color }}
        >
          Prediction
        </span>
      </div>

      <div className="standard-tooltip__item">
        <span className="standard-tooltip__small_key text-capitalize">
          Predicted Value
        </span>
        <span className="standard-tooltip__value">
          {formatQueryMetric(tooltipPayload.metric_id, predictedValue, metrics)}
        </span>
      </div>

      <div className="standard-tooltip__item">
        <span className="standard-tooltip__small_key text-gray">
          Range of Uncertainty:
        </span>
        <span className="standard-tooltip__value">&nbsp;</span>
      </div>

      <div className="standard-tooltip__item">
        <span className="standard-tooltip__small_key text-capitalize">
          Highest Value
        </span>
        <br />
        <span className="standard-tooltip__value">
          {formatQueryMetric(tooltipPayload.metric_id, highestValue, metrics)}
        </span>
      </div>

      <div className="standard-tooltip__item">
        <span className="standard-tooltip__small_key text-capitalize">
          Lowest Value
        </span>
        <span className="standard-tooltip__value">
          {formatQueryMetric(tooltipPayload.metric_id, lowestValue, metrics)}
        </span>
      </div>
    </main>
  );
};

QueryBuilderTooltipPrediction.propTypes = {
  tooltipPayload: PropTypes.object.isRequired,
  metrics: PropTypes.array.isRequired,
};

export default QueryBuilderTooltipPrediction;
